export default {
	form: {
		required_error: 'यह फ़ील्ड आवश्यक है',
		max_length_exceeded_error:
			'यह फ़ील्ड बहुत लंबा है (अधिकतम {{length}} अक्षर)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - सर्वाधिकार सुरक्षित',
		i_consent: 'मैं सहमत हूँ',
		agreement_title: 'समझौता',
		agreement_content:
			'Gerositus का उपयोग करके, आप हमारी <1>नियम व शर्तें</1> और <2>गोपनीयता नीति</2> से सहमत होते हैं।',
		agreement_terms_conditions: 'नियम व शर्तें',
		agreement_privacy_policy: 'गोपनीयता नीति',
	},
	navigation: {
		home: 'होम'
	},
	yes: 'हाँ',
	no: 'नहीं',
	not_defined: 'परिभाषित नहीं',
	please_wait: 'कृपया प्रतीक्षा करें',
	search: 'खोजें',
	upgrade_required: 'अपग्रेड आवश्यक',
	create_project_title: 'आप क्या हासिल करना चाहते हैं?',
	click_to_change: 'बदलने के लिए क्लिक करें',
	click_to_create_one: '<button>बनाने के लिए क्लिक करें</button>',
	no_goal: 'कोई लक्ष्य नहीं',
	auth: {
		token_expiring_soon: 'आपका सत्र {{minutes}} मिनट में समाप्त होगा',
		token_expired:
			'आपका सत्र समाप्त हो गया है। आपको लॉगिन पृष्ठ पर भेजा जाएगा।',
		token_check_error: 'टोकन जाँच में त्रुटि',
		session_expiring:
			'आपका सत्र समाप्त होने वाला है। कृपया पुनः कनेक्ट करें। शेष समय: {{time}}'
	},
	bot: {
		placeholder: 'अपना प्रश्न यहाँ लिखें',
		security_notice: 'निजी, पृथक AI। आपकी बातचीत गोपनीय रहती है।'
	},
	tutorial: {
		button: 'ट्यूटोरियल',
		exit_title: 'ट्यूटोरियल से बाहर निकलें',
		exit_confirm: 'क्या आप वाकई ट्यूटोरियल छोड़ना चाहते हैं?'
	},
	subscription: {
		billing_monthly: 'मासिक',
		billing_yearly: 'वार्षिक',
		billing_yearly_save: '(20% बचत)',
		choose_now: 'अभी चुनें'
	},
	icons: {
		used: 'उपयोग में',
		unused: 'अनुपयोगी'
	},
	theme: {
		selector: 'थीम चयन',
		current_theme: 'वर्तमान थीम',
		change_theme: 'थीम बदलें'
	},
	no_description: 'कोई विवरण नहीं',
	situation_analysis: {
		title: 'स्थिति विश्लेषण',
		description:
			'किसी संगठन, कंपनी या स्थिति का स्वचालित विश्लेषण',
		organization_label: 'संगठन / कंपनी',
		organization_placeholder: 'विश्लेषण करने के लिए संगठन का नाम',
		subject_label: 'विषय',
		subject_placeholder:
			'विश्लेषण का विषय (प्रोजेक्ट नाम से पूर्व भरा)',
		launch_analysis: 'विश्लेषण चलाएँ',
		analysis_in_progress: 'विश्लेषण प्रगति पर…',
		complete_analysis: 'विश्लेषण समाप्त करें',
		waiting_analysis: 'विश्लेषण की प्रतीक्षा…',
		waiting_summary: 'सारांश की प्रतीक्षा…',
		waiting_stakes: 'हित की प्रतीक्षा…',
		waiting_risks: 'जोखिम की प्रतीक्षा…',
		waiting_openings: 'ओपनिंग की प्रतीक्षा…',
		waiting_stakeholders: 'हितधारकों की प्रतीक्षा…',
		context_title: 'सामान्य संदर्भ',
		summary_title: 'सारांश',
		stakes_title: 'हित',
		risks_title: 'जोखिम',
		openings_title: 'ओपनिंग',
		stakeholders_title: 'हितधारक',
		status: 'स्थिति',
		likelihood: 'संभावना',
		impact: 'प्रभाव',
		stakeholder: {
			importance_label: 'सापेक्ष महत्व',
			propensity_label: 'प्रवृत्ति',
			engagement_label: 'सहभागिता',
			importance_values: {
				low: 'कम',
				medium: 'मध्यम',
				high: 'उच्च'
			},
			propensity_values: {
				green: 'सहायक',
				neutral: 'तटस्थ',
				orange: 'तनावपूर्ण',
				red: 'प्रतिकूल'
			},
			engagement_values: {
				inactive: 'निष्क्रिय',
				neutral: 'तटस्थ',
				low: 'कम',
				medium: 'मध्यम',
				high: 'मजबूत'
			},
			polarity_values: {
				positive: 'समर्थन',
				negative: 'विरोध'
			}
		},
		risk_category_values: {
			operational: 'परिचालन',
			strategic: 'रणनीतिक',
			existential: 'अस्तित्वगत'
		}
	},
	ai_project_generation: {
		checkbox_label: 'AI से सामग्री उत्पन्न करें',
		checkbox_tooltip:
			"शीर्षक, मिशन, विवरण और नीचे दिए गए परिदृश्यों का उपयोग करता है। सार्वजनिक AI खोज केवल आपकी पुष्टि («प्रोजेक्ट बनाएँ») के बाद शुरू होती है।",
		title: 'AI प्रोजेक्ट जनरेशन',
		go_to_project: 'प्रोजेक्ट पर जाएँ',
		create_project: 'प्रोजेक्ट बनाएँ',
		include_in_project_aria: 'इस आइटम को प्रोजेक्ट में शामिल करें',
		creation_modal_title: 'आइटम बनाए जा रहे हैं',
		creation_progress_text: '{{current}} / {{total}} आइटम बनाए गए',
		error_title: 'जनरेशन त्रुटि',
		complete_title: 'जनरेशन पूर्ण',
		complete_description:
			'आपका प्रोजेक्ट सफलतापूर्वक समृद्ध हुआ। AI ने मुख्य हितधारक, हित, जोखिम और ओपनिंग पहचाने।',
		summary_title: 'विश्लेषण सारांश',
		initializing_text:
			'गहन विश्लेषण तैयार किया जा रहा है… इसमें 6 से 10 मिनट लग सकते हैं।',
		include_in_project_tooltip:
			'जब चेक हो, «प्रोजेक्ट बनाएँ» पर क्लिक करने पर यह आइटम प्रोजेक्ट में बनेगा।',
		language_code: 'hi',
		patience_with_scenarios:
			'परिदृश्य निर्माण जटिल है और कुछ मिनट ले सकता है। आपके धैर्य के लिए धन्यवाद।',
		patience_no_scenarios:
			'गहन विश्लेषण में कुछ मिनट लग सकते हैं। आपके धैर्य के लिए धन्यवाद।',
		phases: {
			initializing: 'प्रारंभ',
			deep_research: 'अनुसंधान',
			analyzing: 'AI विश्लेषण',
			stakeholders: 'हितधारक',
			stakes: 'हित',
			risks: 'जोखिम',
			openings: 'ओपनिंग',
			summary: 'सारांश',
			fishbone: 'कार्य योजना',
			entities: 'इकाइयाँ',
			scenarios: 'परिदृश्य',
			completed: 'पूर्ण',
			error: 'त्रुटि'
			},
		section_title: "AI जनरेशन विवरण",
		disclosure_public_title: "सार्वजनिक AI को",
		disclosure_public_sub: "वेब खोज। केवल नीचे की निष्पक्ष पूर्वावलोकन प्राप्त करता है — कोई इरादा नहीं, कोई लक्ष्य नहीं।",
		disclosure_private_title: "निजी, पृथक AI",
		disclosure_private_sub: "पृथक वातावरण में चलती है। पुनःप्रशिक्षण नहीं, बाहर डेटा प्रसारित नहीं। शीर्षक, मिशन, विवरण और परिदृश्य संसाधित करती है।",
		zone_public: "सार्वजनिक AI को भेजा",
		zone_private: "निजी — सार्वजनिक AI को नहीं भेजा",
		field_private_chip: "निजी और सुरक्षित",
		field_private_tooltip: "पृथक वातावरण में निजी AI द्वारा संसाधित। पुनःप्रशिक्षण नहीं, बाहर डेटा प्रसारित नहीं।",
		preview_title: "खोज पूर्वावलोकन",
		preview_refresh: "पूर्वावलोकन पुनः उत्पन्न करें",
		preview_hint: "आपके विषय का तटस्थ पुनःकथन — किसी इरादे का निशान नहीं। सार्वजनिक खोज को बिल्कुल यही भेजा जाएगा — केवल आपकी पुष्टि के बाद।",
		preview_placeholder: "पूर्वावलोकन के लिए कम से कम प्रोजेक्ट का शीर्षक भरें।",
		launch_generation: "जनरेशन शुरू करें",
		fishbone_source: 'स्रोत पाठ',
		scenario_n: 'परिदृश्य {{n}}',
		scenario_optimistic: 'अनुकूल',
		scenario_baseline: 'सर्वाधिक संभावित',
		scenario_pessimistic: 'प्रतिकूल',
		scenario_pending: 'लंबित',
		scenario_triggers: 'ट्रिगर घटनाएँ',
		scenario_action_window: 'कार्य का समय',
		scenario_detail: 'विस्तृत विश्लेषण',
		dismiss: 'AI सुझाव छोड़ें और प्रोजेक्ट बनाएँ',
		save_pdf: 'PDF के रूप में सहेजें',
		save_hint: 'प्रोजेक्ट में जाने से पहले आप यह विश्लेषण सहेज सकते हैं।',
		scenario_impacts: 'इकाई प्रभाव',
		data: {
			scenarios: 'संभावित परिदृश्य',
			fishbone: 'रणनीतिक कार्य योजना'
		}
	},
	scenario_elaboration: {
		title: 'AI परिदृश्य विस्तार',
		hypothesis: 'परिकल्पना',
		initializing: 'विश्लेषण आरंभ हो रहा है…',
		error_title: 'विस्तार त्रुटि',
		complete_title: 'विस्तार पूर्ण',
		complete_description:
			'परिदृश्य सफलतापूर्वक विस्तृत हुआ। परिवर्तन लागू हो गए।',
		analysis_preview: 'प्रारंभिक विश्लेषण',
		applied_changes: 'लागू परिवर्तन',
		stakeholders_modified: 'हितधारक संशोधित',
		stakes_modified: 'संकेतक संशोधित',
		risks_modified: 'जोखिम/ओपनिंग संशोधित',
		indicators_modified: 'संकेतक संशोधित',
		new_elements: 'नए',
		steps: {
			started: 'शुरू',
			started_desc: 'विश्लेषण आरंभ हो रहा है…',
			fetching_project: 'प्रोजेक्ट लोड हो रहा है',
			fetching_project_desc: 'प्रोजेक्ट डेटा लोड हो रहा है…',
			deep_research: 'प्रारंभिक विश्लेषण',
			deep_research_desc: 'गहन स्थिति विश्लेषण…',
			ai_analysis: 'AI विश्लेषण',
			ai_analysis_desc: 'AI परिकल्पना के प्रभाव का विश्लेषण कर रहा है…',
			reformatting: 'स्वरूपण',
			reformatting_desc: 'परिणाम संरचित किए जा रहे हैं…',
			processing_stakeholders: 'हितधारक',
			processing_stakeholders_desc: 'हितधारक प्रभाव गणना…',
			processing_stakes: 'हित',
			processing_stakes_desc: 'हित प्रभाव गणना…',
			processing_risks: 'जोखिम',
			processing_risks_desc: 'जोखिम प्रभाव गणना…',
			processing_indicators: 'संकेतक',
			processing_indicators_desc: 'संकेतक प्रभाव गणना…',
			completed: 'पूर्ण',
			completed_desc: 'विश्लेषण सफलतापूर्वक पूर्ण',
			error: 'त्रुटि',
			error_desc: 'एक त्रुटि हुई'
		}
	}
};
